export function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/arrays.js
// module id = ./node_modules/@apollo/client/utilities/common/arrays.js
// module chunks = 54 55